import type { ReactNode } from "react";
import { AccessUnreadPage } from "@/app/errors/AccessUnreadPage";
import { NoAccessPage } from "@/app/errors/NoAccessPage";
import { dockEntryAllowed } from "@/app/workspace/dock";
import { useAccess } from "@/shared/api/grants";

export function DockGate({ entry, children }: { entry: string; children: ReactNode }) {
  const access = useAccess();
  if (access === null) return null;
  if (access.unread) return <AccessUnreadPage />;
  return dockEntryAllowed(entry, access) ? children : <NoAccessPage />;
}
